var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.09 8.343.642 1.814a1.07 1.07 0 0 1 0-1.504 1.04 1.04 0 0 1 1.486 0l5.706 5.776L13.54.312a1.04 1.04 0 0 1 1.486 0c.41.414.41 1.088 0 1.503l-6.45 6.528a1.04 1.04 0 0 1-.742.31 1.04 1.04 0 0 1-.743-.31"
})));
export default SvgArrow;